import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";

const API_URL = "/api/admin";

const getStudentWeekWise = async (data) => {
  const { locationID, date } = data;

  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    params: {
      locationId: locationID,
      weekStartingDate: date,
    },
  };
  const response = await axios.get(API_URL + "/all", config);

  return response.data;
};

const adminService = {
  getStudentWeekWise,
};

export default adminService;
